import React from 'react';
import { Button, Dropdown, Form, Modal } from 'semantic-ui-react';
import { SelectField, TextField } from '../../common/FormFields';
import { connect } from 'react-redux';
import { Formik } from 'formik';
import * as selectors from '../../../redux/selectors';
import * as actions from '../../../redux/actions';
import * as api from '../../../api/postApi';
import * as yup from 'yup';
import { bindActionCreators } from 'redux';
import { buildOptionsFromArray } from '../../../utils/buildOptionsFromArray';

const AddPlaceModal = ({ sites, getSites, addNewsItem }) => {
  const [open, setOpen] = React.useState(false);
  const [sections, setSections] = React.useState([]);

  const handleSiteChange = async siteId => {
    const { sections } = await api.getSections(siteId);
    const options = buildOptionsFromArray(sections, 'title', 'id');
    setSections(options);
  };

  const validationSchema = yup.object({
    siteId: yup.string().required('A site is required'),
    sectionId: yup.string().required('A section is required'),
    headline: yup.string().required('A headline is required'),
  });

  const handleSubmit = async (post, formik) => {
    addNewsItem({ ...post, type: 'place' });
    setOpen(false);
    formik.resetForm();
  };

  return (
    <Formik
      initialValues={{ siteId: '', sectionId: '', headline: '' }}
      enableReinitialize
      validationSchema={validationSchema}
      onSubmit={handleSubmit}
    >
      {formik => (
        <Modal
          size="small"
          onClose={() => setOpen(false)}
          onOpen={() => setOpen(true)}
          open={open}
          trigger={<Button icon="plus" labelPosition="left" positive content="Add Place" />}
        >
          <Modal.Header>Add Place</Modal.Header>
          <Modal.Content>
            <Form onSubmit={formik.handleSubmit} widths="equal">
              <Form.Group>
                <Form.Field>
                  <strong>City</strong>
                  <Dropdown
                    fluid
                    search
                    selection
                    clearable
                    options={sites || []}
                    id="siteId"
                    label="Site"
                    name="siteId"
                    value={formik.values.siteId}
                    onChange={(e, { name, value }) => {
                      formik.setFieldValue(name, value);
                      handleSiteChange(value);
                    }}
                    size="small"
                    error={Boolean(formik.errors.siteId)}
                  />
                </Form.Field>
              </Form.Group>
              <Form.Group>
                <SelectField
                  label="Section"
                  id="sectionId"
                  name="sectionId"
                  formik={formik}
                  options={sections}
                  value={formik.values.sectionId}
                  onChange={formik.handleChange}
                  error={Boolean(formik.errors.sectionId)}
                />
              </Form.Group>
              <strong>Working Headline</strong>{' '}
              <span style={{ fontSize: '.8rem' }}>*Creates the slug for your article</span> <br />
              <Form.Group>
                <TextField
                  name="headline"
                  formik={formik}
                  value={formik.values.headline}
                  onChange={formik.handleChange}
                  error={formik.errors.headline}
                  errorMessage={formik.errors.headline}
                />
              </Form.Group>
            </Form>
          </Modal.Content>
          <Modal.Actions>
            <Button color="black" onClick={() => setOpen(false)}>
              Cancel
            </Button>
            <Button
              content="Submit"
              disabled={!formik.isValid}
              labelPosition="left"
              icon="save"
              onClick={formik.handleSubmit}
              positive
            />
          </Modal.Actions>
        </Modal>
      )}
    </Formik>
  );
};

const mapStateToProps = state => ({
  sites: selectors.admin.cultureMapSiteOptions(state),
});

const mapDispatchToProps = dispatch => ({
  getSites: bindActionCreators(actions.admin.getSites, dispatch),
  addNewsItem: bindActionCreators(actions.content.addNewsItem, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(AddPlaceModal);
